export const resolveLogoUrl = async (response) => {
  if (!response?.ok) {
    return null;
  }

  const contentType = response.headers?.get?.('content-type') || '';

  if (!contentType.includes('application/json')) {
    return null;
  }

  try {
    const data = await response.json();
    return data?.urlSchoolLogo || null;
  } catch (err) {
    return null;
  }
};
